import React from "react";
import Heading from "../Heading";
import { Box } from "@mui/material";
import { TailoredStyles } from "../Styles";
import GlobalSubHeading from "../GlobalSubHeading";
import { getMeaning } from "../../utils/localization";

const TailoredProducts = () => {
  return (
    <Box sx={TailoredStyles.mainbannerBox}>
      <Heading title={getMeaning("HME.TAILORDHDNG")} />

      <Box align="center">
        <GlobalSubHeading subTitle={getMeaning("HME.TAILORDSBHDNG1")} />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          my: 4,
        }}
      >
        <Box
          component="img"
          alt=""
          src="images/Products/CircularCompAnimation.svg"
          sx={{
            width: {
              xs: "75%", // Mobile
              sm: "45%", // Small tablets
              md: "35%", // Medium devices
              lg: "30%", // Large desktops
              xl: "35%", // Extra large screens
            },
            maxWidth: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </Box>
    </Box>
  );
};

export default TailoredProducts;
